const identifyUser = async (isLoggedIn: boolean, profileId?: string) => {
  if (!isLoggedIn) {
    return;
  }
  window.proto?.identify(profileId);
};

export default identifyUser;
